import { ColumnResolver } from "@repo/design-system/components/grids";
import { CopyToClipboard } from "@repo/design-system/components/ui";

export const WithCopyable = (renderer, col) => (rowData) => {
    const value = ColumnResolver(col)(rowData);
    return (
        <div className="cell-wrapper">
            <div className="cell-text">
                {renderer(rowData)}
            </div>

            <CopyToClipboard
                value={String(value)}
                {...(col.copyConfig || {})}
            />
        </div>
    );
};
